import { render, staticRenderFns } from "./singleChoiceQuestion.vue?vue&type=template&id=4490f57a&scoped=true&"
import script from "./singleChoiceQuestion.vue?vue&type=script&lang=js&"
export * from "./singleChoiceQuestion.vue?vue&type=script&lang=js&"
import style0 from "./singleChoiceQuestion.vue?vue&type=style&index=0&id=4490f57a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4490f57a",
  null
  
)

export default component.exports